/**
 * Deterministic per-user accent colour for awareness presence (cursor +
 * avatar dot). Same input → same colour across all peers, so everyone
 * sees Dan in the same shade. Eight high-contrast hues — picked to be
 * distinguishable from each other on the dark `bg-ink-950` editor.
 */
const PALETTE = [
  '#f97316', // orange
  '#10b981', // emerald
  '#3b82f6', // blue
  '#a855f7', // purple
  '#ec4899', // pink
  '#eab308', // yellow
  '#06b6d4', // cyan
  '#84cc16', // lime
];

export function colorForUser(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash * 31 + userId.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length] ?? PALETTE[0]!;
}
